import styled from '@emotion/styled/macro';
import { Variables } from '@enter/core';

export const Wrapper = styled.div`
    padding: 20px 0;
`;

export const Title = styled.h1`
    font-size: 24px;
    font-weight: 600;
    color: ${Variables.Colors.n70};
    margin-bottom: 24px;
`;

export const Content = styled.div`
    color: ${Variables.Colors.n50};
`;

export const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 0px;
    margin-bottom: 16px;
`;

